import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Mail, Clock, User, ChevronDown, ChevronUp } from 'lucide-react';
import logger from '@/lib/logger';
import DOMPurify from 'dompurify';

export default function EmailHistory({ leadId }) {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (leadId) {
      api.getLeadEmailHistory(leadId)
        .then(r => setEmails(r.data))
        .catch(err => logger.error(err))
        .finally(() => setLoading(false));
    }
  }, [leadId]);

  if (loading) return null;
  if (emails.length === 0) return null;

  return (
    <div className="border border-slate-200 dark:border-slate-700 rounded-sm bg-white dark:bg-slate-900" data-testid="email-history-section">
      <div className="p-4 border-b border-slate-200 dark:border-slate-700 flex items-center gap-2">
        <Mail className="w-4 h-4 text-[#0047AB]" />
        <h3 className="font-heading font-semibold text-slate-900 dark:text-slate-100 text-sm">Email History ({emails.length})</h3>
      </div>
      <div className="divide-y divide-slate-100 dark:divide-slate-800">
        {emails.map(em => (
          <div key={em.id} className="p-3 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors" data-testid={`email-log-${em.id}`}>
            <div className="flex items-center justify-between cursor-pointer" onClick={() => setExpanded(expanded === em.id ? null : em.id)}>
              <div className="flex items-center gap-2 min-w-0">
                <div className={`w-6 h-6 rounded-full flex items-center justify-center text-white text-[9px] font-bold shrink-0`}
                  style={{ background: em.provider === 'google' ? '#EA4335' : '#0078D4' }}>
                  {em.provider === 'google' ? 'G' : 'M'}
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-medium text-slate-900 dark:text-slate-100 truncate">{em.subject}</p>
                  <div className="flex items-center gap-2 text-[10px] text-slate-400">
                    <span className="flex items-center gap-0.5"><User className="w-2.5 h-2.5" /> {em.user_name}</span>
                    <span className="flex items-center gap-0.5"><Clock className="w-2.5 h-2.5" /> {new Date(em.sent_at).toLocaleString()}</span>
                    <span>To: {em.to_email}</span>
                  </div>
                </div>
              </div>
              {expanded === em.id ? <ChevronUp className="w-3.5 h-3.5 text-slate-400 shrink-0" /> : <ChevronDown className="w-3.5 h-3.5 text-slate-400 shrink-0" />}
            </div>
            {expanded === em.id && (
              <div className="mt-2 ml-8 p-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-sm text-xs text-slate-700 dark:text-slate-300 leading-relaxed" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(em.body) }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
